/**
 * Created by rjulius on 2/11/16.
 */
import Model from "common/framework/Model";
import dateConvert from "common/helper/dateConvert";
export default Model.define({
    id: "id",
    fields: {
        /** The id of the form instance. */
        id: {
            type: "string",
            editable: false,
            nullable: true,
            defaultValue: null
        },

        /** The id of the form design this instance was created from. FormId takes version into account. **/
        formId: {
            type: "string"
        },

        formName: {
            type: "string"
        },

        docId: {
            type: "string",
            transient: true
        },

        description: {
            type: "string"
        },

        /** DateTime when the instance was last edited. */
        lastModifiedDate: {
            type: "date",
            parse: function(val) {
                return dateConvert.toDateUsingClientsTimeZone(val);
            }
        },

        /** Whether or not this instance of the form has already been completed. It can not be edited once completed. **/
        completed: {
            type: "boolean",
            defaultValue: false,
            nullable: false
        },

        /** Whether or not this instance of the form has already been submitted. **/
        submitted: {
            type: "boolean",
            defaultValue: false,
            nullable: false
        },

        disableEdit: {
            type: "boolean",
            transient: true
        },

        // the reference of the gateway page of the form instance for gateway-specific forms
        gatewayPageId: {
            type: "string"
        }
    }
})
